module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_7005.c7698755.png";